import { ItemTypeEnum } from "@jasper/client-models";

export type SplintItemType =
  | typeof ItemTypeEnum.nightGuard
  | typeof ItemTypeEnum.bleachingTray
  | typeof ItemTypeEnum.retainer;

export const SplintItemTypeEnum: Record<SplintItemType, SplintItemType> = {
  [ItemTypeEnum.nightGuard]: ItemTypeEnum.nightGuard,
  [ItemTypeEnum.bleachingTray]: ItemTypeEnum.bleachingTray,
  [ItemTypeEnum.retainer]: ItemTypeEnum.retainer,
};

export const isSplintItemType = (type: string): type is SplintItemType => {
  return Object.values(SplintItemTypeEnum).includes(type as SplintItemType);
};
